import * as React from 'react';

import { Props } from './types';
import { arePropsEqual } from './utils';

const ArrowRight = React.memo(
  ({ className }: Props) => (
    <svg
      data-testid="arrow-right-icon"
      className={className}
      width="14"
      height="32"
      viewBox="0 0 14 32"
    >
      <path d="M0 6.3c0-.2 0-.4.2-.5l1.2-1.2a.7.7 0 011 0l11 10.9.2.5c0 .2-.1.4-.3.5l-10.8 11a.7.7 0 01-1.1 0L.2 26.1l-.2-.5c0-.2 0-.4.2-.5L9.4 16 .2 6.8a.7.7 0 01-.2-.5z" />
    </svg>
  ),
  arePropsEqual
);

export default ArrowRight;
